import { FCompositionType } from '@spazious/dollhouse-graphql';
import { FCompositionTypesEnum } from '@spazious/dollhouse-shallow-graph';

const mapping = {
  [FCompositionType.Ensemble]: FCompositionTypesEnum.FEnsemble,
  [FCompositionType.Arrangement]: FCompositionTypesEnum.FArrangement,
  [FCompositionTypesEnum.FEnsemble]: FCompositionType.Ensemble,
  [FCompositionTypesEnum.FArrangement]: FCompositionType.Arrangement,
} as const;

interface ParseFCompositionTypeFn {
  (type: FCompositionType): FCompositionTypesEnum;
  (type: FCompositionTypesEnum): FCompositionType;
}
/**
 * Parse FCompositionType to FCompositionTypesEnum and vice versa.
 */
export const parseFCompositionType: ParseFCompositionTypeFn = (type: any) => {
  return (mapping as any)[type as any];
};
